// The others' voices, played outside every screen (a part's Background), so
// moving between Me and the workspaces does not stop them. When the browser
// refuses to play by itself, "play audio" is shown and plays only these
// elements on the person's click; it goes when nobody is left to hear.
import { m } from "@trameria/cloud-i18n";
import { Button } from "@trameria/ui-core";
import { useRef, useState } from "react";
import { useVoice, type VoiceSession } from "./lib/session";

export function VoiceAudio({ session }: { session: VoiceSession }) {
  const voice = useVoice(session);
  const box = useRef<HTMLDivElement>(null);
  const [blocked, setBlocked] = useState(false);
  const entries = [...voice.remoteStreams.entries()];
  // Not carried into the next call.
  if (blocked && entries.length === 0) setBlocked(false);
  if (entries.length === 0) return null;
  return (
    <div
      ref={box}
      data-voice-audio=""
      // Above the phone's Dock (`--dock-clearance` is set only in the phone
      // layouts; it covered the Dock's last button before).
      style={{ bottom: "calc(var(--dock-clearance, 0px) + 12px)" }}
      className="fixed right-3 z-40 flex flex-col items-end gap-1"
    >
      {entries.map(([userId, stream]) => (
        <audio
          key={userId}
          autoPlay
          playsInline
          ref={(el) => {
            if (!el || el.srcObject === stream) return;
            el.srcObject = stream;
            el.play?.().catch(() => setBlocked(true));
          }}
        >
          {/* A live voice has no captions; an empty track for the a11y rule. */}
          <track kind="captions" />
        </audio>
      ))}
      {blocked && (
        <Button
          variant="primary"
          onClick={() => {
            for (const a of box.current?.querySelectorAll("audio") ?? [])
              a.play?.().catch(() => {});
            setBlocked(false);
          }}
        >
          {m.vc_play_audio()}
        </Button>
      )}
    </div>
  );
}
